import { areElementsIncluded } from './array';
import * as chroma from 'chroma-js';

/**
 * Retrieves the display value for selected options in a pill.
 *
 * - If only one option is selected, it returns the value of the selected option.
 * - If all available options are selected, it updates the `allValuesSelected` property to true and returns 'All values'.
 * - If multiple but not all options are selected, it returns 'Multiple values'.
 *
 * @returns {string} The display value representing the selected options.
 */
export function selectedValuesPill(selected: any[], available: any[]): string {
    if (selected.length === 1) {
        return selected[0];
    }

    if (areElementsIncluded(available, selected)) {
        return 'All values';
    }
    return `Multiple values (${selected.length})`;
}

export function generateGradientColors(
    startColor: string,
    endColor: string,
    n: number
) {
    const scale = chroma.scale([startColor, endColor]).mode('lch');
    return Array.from({ length: n }, (_, i) => scale(i / (n - 1)).hex());
}
